import script from "./EmployeesWithPendingVacationDays.vue?vue&type=script&setup=true&lang=js"
export * from "./EmployeesWithPendingVacationDays.vue?vue&type=script&setup=true&lang=js"

import "./EmployeesWithPendingVacationDays.vue?vue&type=style&index=0&id=876c055c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-876c055c"]])

export default __exports__